import { computed, Directive, input } from '@angular/core';

@Directive({
  selector: 'img[app-image]',
  standalone: true,
  host: {
    '[attr.src]': 'src()',
    '[attr.alt]': 'finalAlt()',
    '[attr.loading]': 'loading()',
  },
})
export class ImageDirective {
  // All bindable, reactive inputs
  src = input.required<string>();
  alt = input<string>();
  loading = input<'lazy' | 'eager'>('eager');

  finalAlt = computed(() => {
    return this.alt() || this.getAltFromSrc(this.src());
  });

  private getAltFromSrc(src: string): string {
    if (!src) return '';
    const filename = src.split('/').pop() ?? '';
    const nameWithoutExt = filename.split('.')[0];
    return nameWithoutExt.replace(/[-_]/g, ' ');
  }
}
